import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

export default function ProtectedRoute({ children, requiredRole }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div style={{ display:'flex', alignItems:'center', justifyContent:'center', height:'100vh' }}>
        <span style={{ color:'#64748b', fontSize:'1rem' }}>Loading…</span>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredRole) {
    const order = { admin: 3, manager: 2, viewer: 1 };
    if ((order[user.role] || 0) < (order[requiredRole] || 0)) {
      return <Navigate to="/" replace />;
    }
  }

  return children;
}
